import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { GoalConfigForm } from 'modules/goals/lib/GoalConfigForm'
import goalsConfig from 'modules/goals/store/collections/goalsconfig'

export const useGoal = (goalConfigId: number) => {
  const [goalConfig, setGoalConfig] = React.useState(goalsConfig.get(goalConfigId))

  const [form, setForm] = React.useState(new GoalConfigForm({}))
  React.useEffect(() => {
    if (!goalConfig) return

    setForm(new GoalConfigForm(goalConfig.toJS()))
  }, [goalConfig])

  const { loading } = useAsyncData(async () => {
    if (goalConfig) return

    await goalsConfig.fetch()
    setGoalConfig(goalsConfig.get(goalConfigId))
  }, [goalConfigId])

  return {
    loading,
    goalConfig,
    form,
  }
}
